module.exports = __webpack_public_path__ + "static/media/1Specialties.4f48b992.svg";